// import { createDevTools } from 'redux-devtools';
// import LogMonitor from 'redux-devtools-log-monitor';
// import DockMonitor from 'redux-devtools-dock-monitor';

import React from 'react';
import ReactDOM from 'react-dom';
import { applyMiddleware, createStore, compose } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import WebSocketProvider from './containers/socket/webSocket';
import AlgoSignalProvider from './containers/socket/signalAlgo';
import { WindowContextProvider } from './containers/windowActive';

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import {
  HashRouter as Router,
  // BrowserRouter as Router,
  Switch,
  Route,
  // useParams,
  Redirect,
} from 'react-router-dom';

import './index.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'assets/css/analysis.css';

import App from './App';
import DefaultLayout from './containers/defaultLayout';

// Import the index reducer and sagas
import IndexReducer from './reducers';
import IndexSagas from './sagas';

import Loading from './components/loading';

// Setup the middleware to watch between the Reducers and the Actions
const sagaMiddleware = createSagaMiddleware();

/*eslint-disable */
const composeSetup =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
/*eslint-enable */

/* redux-devtools */
// const DevTools = createDevTools(
//   <DockMonitor toggleVisibilityKey="ctrl-h" changePositionKey="ctrl-q">
//     <LogMonitor theme="tomorrow" preserveScrollTop={false} />
//   </DockMonitor>
// );

// const store = createStore(
//   IndexReducer,
//   composeSetup(applyMiddleware(sagaMiddleware), DevTools.instrument()) // allows redux devtools to watch sagas
// );

/* prod */
const store = createStore(
  IndexReducer,
  composeSetup(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(IndexSagas);

/* disable console log when production build */
let consoleHolder = console;
function debug(bool) {
  if (!bool) {
    consoleHolder = console;
    console = {};
    Object.keys(consoleHolder).forEach(function (key) {
      console[key] = function () {};
    });
  } else {
    console = consoleHolder;
  }
}

debug(process.env.NODE_ENV !== 'production');

/* end disable console log */

ReactDOM.render(
  <Provider store={store}>
    <WindowContextProvider>
      <WebSocketProvider store={store}>
        {/* <AlgoSignalProvider> */}
          <I18nextProvider i18n={i18n}>
            <Router basename={process.env.PUBLIC_URL}>
              <React.Suspense fallback={<Loading />}>
                {/* <GlobalStyles /> */}
                <Route path="/" component={App}>
                  <Switch>
                    {/**
                <Route exact path="/login" name="Login Page" component={Login} />
                */}
                    <Route
                      path="/home"
                      component={() => (
                        <DefaultLayout store={store} i18n={i18n} />
                      )}
                    />
                    <Redirect from="/" to="/home/bang-gia" />
                  </Switch>
                </Route>
              </React.Suspense>
            </Router>
            {/* <DevTools /> */}
          </I18nextProvider>
        {/* </AlgoSignalProvider> */}
      </WebSocketProvider>
    </WindowContextProvider>
  </Provider>,
  document.getElementById('root')
);
